import { useLocation } from 'react-router-dom';
import { useEffect } from 'react';
import { useLocationContext } from '../../context';

/*
 * This component is used to set the current location whenever the location changes which will be used to configure datadog rum user.
 * It is used to solve the issue that the user data is not set when datadog is initialized using datadogRum.init in useDatadogRum.tsx file.
 */
export const LocationContextUpdater = () => {
  const location = useLocation();
  const { setCurrentLocation } = useLocationContext();

  useEffect(() => {
    setCurrentLocation?.(location.pathname);
  }, [location.pathname, setCurrentLocation]);

  return null;
};
